export default __webpack_public_path__ + "50d104f60f47e2b2600835ef20e6b1d2.png";